import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger } from "@/components/ui/alert-dialog";
import DropZone from "@/components/ui/dropzone";
import React from "react";
import { Button } from "./button";

export function FileUpload({
    bucketName,
    folderPath,
    title = "Upload a file",
    buttonText = "Save",
    url,
    onUpload
}: {
    bucketName: string;
    folderPath?: string;
    title?: string;
    buttonText?: string;
    url?: string;
    onUpload?: (url: string) => void;
}) {
    const [file, setFile] = React.useState<string>("");

    return (
        <AlertDialog>
            <AlertDialogTrigger asChild>
                <Button type="button" variant="outline" className="w-full">
                    {url ? "See file" : "Add file"}
                </Button>
            </AlertDialogTrigger>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>{title}</AlertDialogTitle>
                </AlertDialogHeader>
                {url && (
                    <a href={url} target="_blank" className="text-blue-500 underline">
                        Current file
                    </a>
                )}
                <DropZone
                    required
                    maxFiles={1}
                    maxSize={10}
                    accept={{
                        "image/*": [".png", ".jpeg"],
                        "application/pdf": [".pdf"]
                    }}
                    bucketName={bucketName}
                    folderPath={folderPath}
                    onUploaded={(url: string) => {
                        setFile(url);
                    }}
                />
                <AlertDialogFooter>
                    <AlertDialogCancel>Cancel</AlertDialogCancel>
                    <AlertDialogAction
                        type="button"
                        disabled={!file}
                        onClick={() => {
                            if (file && onUpload) {
                                onUpload(file);
                            }
                        }}
                    >
                        {buttonText}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
}
